var map = {
	"./AED.png": 15638,
	"./BHD.png": 18838,
	"./CAD.png": 57540,
	"./CHF.png": 32293,
	"./DHS.png": 88927,
	"./DKK.png": 95770,
	"./EUR.png": 46911,
	"./GBP.png": 81545,
	"./GIP.png": 92204,
	"./JPY.png": 53379,
	"./KWD.png": 88586,
	"./NOK.png": 66544,
	"./OMR.png": 17722,
	"./QAR.png": 85244,
	"./SAR.png": 36402,
	"./SEK.png": 42911,
	"./USD.png": 3468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68913;